import React from 'react';
import { Table, Checkbox } from 'semantic-ui-react';
import './styles.scss';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';
import CONSTANT from '../../core/constant/constant';
import { commonConstants } from '../../core/constant/common.constants';

class TableCustom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectRow: '',
            sort: 'ASC',
            classSort: 'descending sorted',
            headerClick: '',
            btnClicked: false
        }
    }

    componentWillMount() {
        const { dataList } = this.props;
        this.setState({
            data: dataList || []
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.unSelectRow !== true) {
            this.setState({
                selectRow: ''
            })
        }

        if (nextProps.defaultSort && nextProps.defaultSort.indexOf("ASC") !== -1) {
            this.setState({
                sort: 'ASC',
                classSort: 'descending sorted',
                headerClick: ''
            })
        }

        this.setState({
            data: nextProps.dataList || []
        })
    }

    // handle row click
    handleRowClick = (val) => {
        this.setState({ selectRow: val['id'] });
        this.props.onRowClick(val);
    }

    // handle click Sort
    handleSort = async (val) => {
        await (this.state.sort === 'ASC') ? (this.setState({
            sort: 'DESC',
            classSort: 'ascending sorted',
            headerClick: val
        })) : (
                this.setState({
                    sort: 'ASC',
                    classSort: 'descending sorted',
                    headerClick: val
                })
            );

        return this.props.sortBy(this.state.headerClick + '-' + this.state.sort);
    }

    buttonClick = (e, employeeId, month, year) => {
        e.stopPropagation();
        this.setState({
            btnClicked: true
        });
        window.location = CONSTANT.apiUrl + "Approve/detailUserLogWork?secretKey="
                        + this.props.secretKey + "&employeeId=" + employeeId
                        + "&month=" + month + "&year=" + year + "&sortBy=createdDate-ASC&projectBy=projectCode-asc&projectId=&lang=" + localStorage.i18nextLng;
    }

    // render body
    content = (val, data) => {
        const { tableStructure, month, year, t } = val;
        if (data && !data[0]) return;
        return (
            data.map((item, i) =>
                <Table.Row
                    key={i}
                    disabled={this.props.isWorkingHourPage && commonConstants.DISABLED_PROJECT.findIndex((ele) => ele === item.projectCode) >= 0}
                    onClick={(e) => this.handleRowClick(item)}
                    className={this.state.selectRow === item.id ? 'active' : ''}
                >
                    {
                        tableStructure.map(ite =>
                            (ite.type === 'id') ? (
                                <Table.Cell className={(ite.isClass ? ite.isClass : '')} key={ite.type} data-title={t(ite.label)}>{i + 1}</Table.Cell>
                            ) :
                                <Table.Cell className={(ite.isClass ? ite.isClass : '')} key={ite.type} data-title={t(ite.label)}>
                                    {ite.type === 'action' ? <button disabled={this.state.btnClicked} onClick={e => this.buttonClick(e, item.employeeId, month, year)} className={(ite.isClassButton)? ite.isClassButton : "ui primary button"}>{t(ite.action)}</button> :
                                        <span>{
                                            (ite.isValueInArray && ite.isValueInArray === true)
                                                ? (
                                                    (item[ite.subType]) ? item[ite.subType].map((subItem, j) =>
                                                        (ite.isCheckbox && ite.isCheckbox === true)
                                                            ? <Checkbox key={j} readOnly checked={subItem[ite.type] == true ? true : false} />
                                                            : <span key={j} className="break-word">
                                                                {((ite.isChangeText && ite.isChangeText === true) ? t(ite.arrayTextChange[subItem[ite.type]]) : subItem[ite.type])}
                                                                </span>
                                                    ) : ''
                                                )
                                                : (
                                                    (ite.isCheckbox && ite.isCheckbox === true)
                                                        ?
                                                        <Checkbox readOnly checked={item[ite.type] == true ? true : false} />
                                                        :
                                                        ((ite.isChangeText && ite.isChangeText === true) ? t(ite.arrayTextChange[item[ite.type]]) : item[ite.type])
                                                )

                                        }</span>
                                    }
                                </Table.Cell>
                        )
                    }
                </Table.Row>
            )
        )
    }

    // render header
    tableHeader = (val) => {
        const { tableStructure, t } = val;
        return (
            tableStructure.map(item =>
                (item.sort && item.sort === true)
                    ?
                    <Table.HeaderCell key={item.type} id={item.type}
                        onClick={(e) => this.handleSort(item.type)}
                        className={(this.state.headerClick === item.type ? this.state.classSort : 'descending sorted') + ' ' + (item.isClass ? item.isClass : '')}
                    >{t(item.label)}</Table.HeaderCell>
                    :
                    <Table.HeaderCell key={item.type} id={item.type} className={item.isClass}>{t(item.label)}</Table.HeaderCell>
            )
        )
    }

    tableTotal = (val) => {
        const { tableStructure, t, isTotal, totalOtDay, totalWorkingHourDay } = val;
        if (isTotal !== true) return
        return (
            <Table.Row className='table-total'>
                {
                    tableStructure.map(ite =>
                        (ite.type === 'id') ? (
                            <Table.Cell className={(ite.isClass ? ite.isClass : '')} key={ite.type}><b>{t("table.total")}</b></Table.Cell>
                        ) :
                            (ite.type === 'normalTime') ? (
                                <Table.Cell className={(ite.isClass ? ite.isClass : '')} key={ite.type} data-title={t(ite.label)}>{totalWorkingHourDay}</Table.Cell>
                            ) :
                                (ite.type === 'overtimeHour') ? (
                                    <Table.Cell className={(ite.isClass ? ite.isClass : '')} key={ite.type} data-title={t(ite.label)}>{totalOtDay}</Table.Cell>
                                ) :
                                <Table.Cell className={(ite.isClass ? ite.isClass : '')} key={ite.type} data-title={t(ite.label)}></Table.Cell>
                    )
                }
            </Table.Row>
        )
    }

    render() {
        return (
            <div className="table-list">
                <Table sortable celled size="small">
                    <Table.Header>
                        <Table.Row>
                            {this.tableHeader(this.props)}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.content(this.props, this.state.data)}
                        {this.tableTotal(this.props)}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

export default compose(
    withTranslation(),
)(TableCustom);
